import {
    CommandResponse,
    EntityCommandCreateResponse,
    RevisionedCommandResponse,
    ScheduledDay,
    toScheduledDay,
} from '@faro/study-designer-model';
import { ScheduleOfActivitiesQueryParameter, StudyPathParameter, VariantQueryParameter } from '../parameter';
import axios from 'axios';

export type ScheduledDayPathParameters = StudyPathParameter;
export type ScheduledDayQueryParameters = ScheduleOfActivitiesQueryParameter &
    VariantQueryParameter & {
        /**
         * Comma delimited list of {@link ScheduledDayType}.
         */
        types?: string;
    };

export type ScheduledDayDuplicateRequest = {
    studyId: string;
    id: string;
    days: { [key: string]: number[] } | number[];
};

export type ScheduledDayActivityModifyCardinalityRequest = {
    studyId: string;
    id: string;
    activityId: string;
    cardinality: number;
};

/**
 * Client responsible for accessing the backend entity services
 */
export const scheduledDayClient = {
    list: (request?: ScheduledDayPathParameters & ScheduledDayQueryParameters): Promise<ScheduledDay[]> => {
        const { studyId, ...query } = request ?? {};
        return axios
            .get(`/api/study-designer/studies/${studyId}/scheduled-days`, { params: query })
            .then(response => response.data?.map(toScheduledDay));
    },

    clone: (params: ScheduledDayDuplicateRequest): Promise<RevisionedCommandResponse<EntityCommandCreateResponse>> => {
        return axios
            .post(`/api/study-designer/studies/${params.studyId}/scheduled-days/${params.id}/actions/clone`, params)
            .then(response => response.data);
    },

    update: ({
        studyId,
        ...entity
    }: ScheduledDay & ScheduledDayPathParameters): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .put(`/api/study-designer/studies/${studyId}/scheduled-days/${entity.id}`, entity)
            .then(response => response.data);
    },

    delete: ({
        studyId,
        id,
    }: ScheduledDay & ScheduledDayPathParameters): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .delete(`/api/study-designer/studies/${studyId}/scheduled-days/${id}`)
            .then(response => response.data);
    },

    modifyCardinality: async (
        params: ScheduledDayActivityModifyCardinalityRequest,
        signal?: AbortSignal
    ): Promise<RevisionedCommandResponse<CommandResponse>> => {
        return axios
            .post(
                `/api/study-designer/studies/${params.studyId}/scheduled-days/${params.id}/actions/modify-cardinality`,
                params,
                { signal }
            )
            .then(response => response.data);
    },
};
